
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const Vertical3DotsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.997 17.502c-.275 0-.5.225-.497.5 0 .276.225.5.5.5s.5-.224.5-.5c0-.275-.225-.5-.503-.5M11.997 11.5c-.275 0-.5.225-.497.5 0 .275.225.5.5.5s.5-.225.5-.5-.225-.5-.503-.5M11.997 5.497c-.275 0-.5.225-.497.5 0 .276.225.5.5.5s.5-.224.5-.5c0-.275-.225-.5-.503-.5"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
  </SvgIcon>
);
